"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLink = void 0;
var translate_1 = require("utils/translate");
var createLink = function (file, baseUrl, isMobile, token, section) {
    if (file.type === 'FOLDER') {
        return baseUrl.replace(/\/[^\/]*$/, "/".concat(file.id));
    }
    var selectedLanguage = (0, translate_1.getLanguage)();
    var uiLanguage = "".concat(selectedLanguage, "-").concat(selectedLanguage.toUpperCase());
    if (isMobile) {
        switch (file.type) {
            case 'PDF':
                return "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid, "?preview=true");
            case 'PRESENTATION':
            case 'SPREADSHEET':
            case 'TEXT':
                if (/\.(doc|docx|ppt|pps|pptx|xls|xlsx)$/i.test(file.name)) {
                    var url = "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid, "?token=").concat(token, "&preview=true&uriencoded=true");
                    return "https://view.officeapps.live.com/op/view.aspx?embedded=true&src=".concat(encodeURIComponent(url), "&ui=").concat(uiLanguage);
                }
        }
    }
    if (section) {
        return "".concat(baseUrl, "/").concat(section, "/preview/").concat(file.fileUuid, "/revision/").concat(file.uuid);
    }
    return "".concat(baseUrl, "/preview/").concat(file.fileUuid, "/revision/").concat(file.uuid);
};
exports.createLink = createLink;
